module.exports = __webpack_public_path__ + "img/you-thumbnail.4a427d7e.jpg";